module.exports = __webpack_public_path__ + "static/img/gjzcx.b169929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gjzcx.jpg
// module id = 7Cqh
// module chunks = 4